export const cabaLocalities=[
    {"afip":"21700","location":"Capital Federal"}
    ]